<template>
  <div id="app">
    <Navigation />
    <Wizard />
    <Output />
  </div>
</template>

<style lang="scss">
#app {
  display: flex;
  flex: 1;
}
</style>

<script>
import Navigation from './components/Navigation.vue';
import Wizard from './components/Wizard.vue';
import Output from './components/Output.vue';

export default {
  name: 'App',
  components: {
    Navigation,
    Wizard,
    Output,
  },
};
</script>
